module.exports = require('./helpers/bundle-url').getBundleURL('41p19') + "../loading-image.db0bdd92.gif";